import React from "react"
import Logo from "../../assets/logo.svg";
import "./index.scss";


const Header: React.FC = () => {
    return (
        <header className="header">
        <img className="logo" src={Logo} alt="Logo Sicredi" onClick={() => window.location.href = "https://www.sicredi.com.br/home/"}/>
      </header>
    )
}

export default Header;